import {ssoLogin} from '../actions/auth';

const zh_CN = {
    20: 'OPEN',
    24: '账户审核中',
    25: '账户部分审核通过',
    27: '账户未通过审核',
    30: '订单提交中',
    40: '订单提交中',
    50: '订单处理中',
    90: '订单已取消',
    100: '现货中心订单',
    240: '订单等候处理',
    270: '账户审核中',
    280: '订单已提交',
    300: 'NOT_STARTED',
    320: '订单已完成',
    800: '订单审核中',
    801: '订单已发货',
    LEGACY: '',
    register: '注册',
    supplyCenter: '现货中心',
    supplyCenterId: '现货中心',
    required: '此项为必填',
    accountNotExit: '您的手机号不存在，请重新输入',
    passwordNotValid: '您的密码有误，请重新输入',
    name: '姓名',
    firstName: '名',
    lastName: '姓',
    institution: '公司/单位名称',
    labOrDept: '课题组名称',
    contactInformation: '联系方式',
    mobile: '手机号',
    phone: '固话',
    email: '邮箱',
    shipToName: '收货人名称',
    shipToPhone: '联系方式',
    please_input_correct_phone_number:
        '注意：您输入的联系方式格式可能不对，若您确认无误，请忽略',
    shipToStateName: '省',
    shipToCityName: '市',
    shipToStateId: '省',
    shipToCityId: '市',
    shipToAddress: '详细地址',
    billToName: '收货人名称',
    billToPhone: '联系方式',
    billToEmail: '邮箱',
    invoiceTitle: '发票信息',
    billToStateName: '省',
    billToCityName: '市',
    billToStateId: '省',
    billToCityId: '市',
    billToAddress: '详细地址',
    code: '验证码',
    registerSuccess: '注册成功',
    registerFailure: '注册失败',
    noticeOne: '注意:以下内容全部为必填项!',
    baseInfo: '基本信息',
    shipInfo: '收货信息',
    billInfo: '发票收货信息',
    sameShipInfo: '同收货人信息',
    errorMobile: '联系方式输入不合法',
    errorEmail: '邮箱输入不合法',
    duplicateEmail: '此邮箱已被使用',
    unusedEmail: '查无此账户，请注册新账户',
    receiveNotification:
        '我希望通过电话、电子邮件或其他方式接受Thermo Fisher Scientific 产品和服务信息',
    registerAccount: '注册账户',
    noticeTwo:
        '点击“注册账户”按钮使用本网站购买产品和服务，即表示您已接受并同意：',
    useClauses: '使用条款',
    termsConditions: '条款和条件',
    thermofisher: '赛默飞世尔科技网',
    noticeThree: '您在本网站购买的产品和服务的销售',
    privacy: '隐私政策',
    pricingConsignment: '定价及代销政策',
    getCode: '获取验证码',
    sendSuccess: '验证码已成功发送至您的邮箱',
    sendFailure: '此账户暂时无法收到验证码，请注册新账户或联系CSR/销售',
    loginSuccess: '登录绑定成功',
    loginFailure: '登录绑定失败',
    isBindingEmail: '此邮箱已经被绑定了',
    invalidCode: '无效的验证码',
    codeOverdue: '验证码已过期',
    enterEmail: '请输入您在赛默飞官网的邮箱',
    noticeFour: '提示：验证码将在2小时后失效，请勿提供给他人！',

    ssoLoginLabel: 'SSO登录',
    accountLoginLabel: '账号登录',

    selectProduct: '选择商品',
    cancel: '取消',
    addToShoppingCart: '加入购物车',
    enterProductName: '输入商品名称/货号',
    allProduct: '全部商品',
    canShip: '可送货',
    moreDetails: '产品详情',
    productDetails: '商品详情',
    getInfo: '我知道了',
    shipTo: 'ShipTo',
    shippingAddress: '收货地址',
    billAddress: '发票收货地址',
    setDefault: '设为默认',
    setTemporaryST: '选择收货地址',
    showDeliveryAddress: '送至：',
    setDefaultAddress: '选择默认地址',
    sku: '货号',
    product_name: '产品名称',
    modify: '修改',
    expectDeliveryDateTitle: '修改期望发货时间',
    refund_sku: '货号',
    refund_lot: '批次号',
    inventory: '库存',
    specifications: '规格',
    storeCondition: '存储条件',
    listPrice: '目录价',
    shoppingCart: '购物车',
    moreThermofisherProduct: '赛默飞官网继续搜索',
    clickMeToContinueSearching: '点我继续搜索',
    pleaseContinueIfNotFound: '没找到你的产品？点击按钮可继续搜索并下单',
    selectCustomer: '选择客户',
    searchCustomer: '输入课题组/姓名/ShipTo/邮箱',
    searchB2bPlatformCustomer: '输入课题组/ShipTo',
    notFoundCustomer: '未找到相关用户',
    noShiptoCustomer: '查看其他暂无绑定的客户',
    billOverdue: '账户冻结',
    telephone: '收货电话',
    inventoryWarning: '库存以实际情况为准！',
    default: '默认',
    scName: '现货中心名称',
    scNumber: '编号',
    orderConfirmation: '订单确认',
    consignee: '收货人',
    poNumber: 'PO(采购单号)：',
    poNumberTF: 'PO(采购单号)：',
    discountCode: '促销代码：',
    note: '备注：',
    noteTF: '备注：',
    remark: '备注',
    apply: '应用',
    productInfo: '商品信息',
    chooseOtherAddress: '选择其他地址',
    shipToConsignee: '收货人',
    billToConsignee: '收货人',
    submitOrderFailure: '订单提交失败',
    updateShipmentPhoneInformationReminder:
        '提醒：短信通知电话必须是 收件人联系方式或者账户默认联系方式，请检查并更新您选择的联系方式',
    replenishmentMgmt: '补货管理',
    feedback: '意见反馈',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    beginTime: '起始时间',
    endTime: '结束时间',
    district: '地区',
    abnormalDescription: '异常说明',
    approvalDescription: '审批说明',
    lotNo: '批次号',
    expireDate: '过期时间',
    expectShipDate: '期望发货时间：',
    SupplyCenterType: '现货',
    TfsType: '官网',
    scChangeTfsTypeMessage: '该产品{0}已超过库存限制,将自动转为网站物流.',
    quickAddSkuValue: '货号',
    quick_add_sku_success: '快速加车产品已添加到购物车',
    sku_is_not_null: '货号不能为空',

    TfsProductSearch: '赛默飞网站产品搜索',
    inputProductNameAndSKU: '输入产品名称/货号',
    apply_associated_supply_center: '申请关联现货中心',
    demo_site_order_add_shopping_cart: '加入购物车',
    quickly_add_product: '快速添加产品',
    shopping_cart_quickly_add_product: '快速加车',
    demo_site_add_sku_button: '添加货号',
    demo_site_delete_sku_row_button: '删除',
    quickly_batch_add_product_need_three_sku: '快速添加产品至少保留三行',
    input_sku_duplicate: '输入的SKU重复',
    enter_information_at_least_one_sku: '请至少输入一个sku信息',
    tfs_sku_not_pricr_not_sales: '官网SKU:{0}没有价格，不允许售卖',
    quickly_add_sku_no_sku: 'sku:{0}不存在',
    quickly_add_sku_is_fsbio: '此产品暂不支持代下单',
    no_search_sku_result: '无法找到与搜索项相匹配的产品',
    please_use_precision_search: '请使用精确货号或英文关键词搜索',
    please_use_quickly_add_sku_function: '请尝试下方【快速添加产品】功能',
    invalid_shipTo: '该ST是无效的ShipTo',
    other_division_no_perssion:
        '此产品归属于{0}您暂无更多查看权限。若您有更多问题，请联系关联现货中心Admin 进行反馈',

    activity_more_details: '更多详情',
    activity_pick_up: '收起',
    activity_introduce: '活动介绍',
    activity_details: '活动详情',

    product_more_details: '查看详情',
    proudct_details: '商品详情',
    product_sku: '货号',
    product_sku_colon: '货号:',
    product_specifications: '规格',
    product_specifications_colon: '规格:',
    product_add_to_shopping_cart: '加入购物车',
    product_infomation: '商品信息',
    porduct_discount_price: '(折后价格)',
    porduct_quote_price: '折后价：',
    porduct_total_quantity: '共{0}件商品',
    porduct_quote_details: '促销信息',
    porduct_discount: '折扣：',
    porduct_min_quantity: '起订量：',
    quote_icon: '促',
    quote_details: '查看促销',
    porduct_shopping_cart_used: '*请前往购物车应用促销代码',
    porduct_search_history: '最近搜索',
    product_view_items: '查看促销活动适用商品',
    product_eta: '预计有货时间',
    product_estimated_ship_date: '预计发货日期',
    product_crd_date: 'CRD',
    product_crd_date_current: '当前期望发货日期',
    product_crd_date_new: '新期望发货日期',
    order_product_group_shipped: '已发货',
    order_product_group_not_shipped: '未发货',
    order_date_range: '可选日期范围:',
    order_date_range_not_available: '暂无可选日期',
    crd_select_to_modify: '选择要同时修改的行',
    order_invoice_title: '发票抬头',
    order_invoice_important_reminder: '重要提醒：',
    order_invoice_important_reminder_rule_1: '请按照最新版《',
    order_invoice_important_reminder_rule_2: '赛默飞中国销售订单入单制度',
    order_invoice_important_reminder_text:
        '》核查所有入单支持文件是否均已齐备。',
    order_invoice_important_reminder_rule_title_new:
        '当订单金额超过入单豁免线时',

    offline_order_invoice_important_reminder_rule_title_new:
        '当订单金额超过入单豁免线时 您需要在订单提交时上传以下入单凭证。',
    offline_order_invoice_important_reminder_rule_title_new_part1:
        '此订单金额已超过入单豁免线（即人民币6万元）您需要在订单提交时上传以下入单凭证',
    offline_order_invoice_important_reminder_rule_title_new_part2:
        '（合同/PO）。',
    offline_order_invoice_important_reminder_total_limit_exceed_part1:
        '您当前未添加任何入单所需凭证，若未及时添加入单所需合同凭证，订单将会一直处于锁定状态无法进入下一流程，您可选择：',
    offline_order_invoice_important_reminder_total_limit_exceed_part2:
        '返回订单确认页面添加入单所需合同/PO凭证。',
    offline_order_invoice_important_reminder_total_limit_exceed_part3:
        '若您当前无凭证提供，请在订单提交后及时在现货中心订单详情页补充入单合同凭证。',
    order_invoice_offline_reminder: '重要提醒',
    order_invoice_important_reminder_rule_1_1_new: '请遵照《',
    order_invoice_important_reminder_rule_1_2_new: '销售订单入单制度',
    order_invoice_important_reminder_rule_1_3_new: '确保入单支持文件齐全',
    order_invoice_important_reminder_rule_1_4_new: '，且必须与客户签订',
    order_invoice_important_reminder_rule_1_5_new: '双章销售合同',
    order_invoice_important_reminder_rule_1_6_new: '》，',
    order_invoice_important_reminder_rule_1_7_new: '。',

    order_invoice_important_reminder_rule_2_1_new:
        '发货地址变更时，请按照公司《',
    order_invoice_important_reminder_rule_2_2_new: '交货地址变更政策',
    order_invoice_important_reminder_rule_2_3_new: '》，',
    order_invoice_important_reminder_rule_2_4_new: '提供符合要求的地址确认文件',
    order_invoice_important_reminder_rule_2_5_new: '。',

    order_invoice_important_reminder_rule_3_1_new:
        '如有问题，及时联系财务内控部。',

    order_invoice_important_reminder_text_new:
        '》核查所有入单支持文件是否均已齐备。',
    order_po_number_colon: 'PO(采购单号):',
    order_remark_colon: '备注:',
    order_ship_info: '收货信息',
    order_consignee: '收货人',
    order_contact: '联系方式',
    order_address: '地址',
    order_subject: '课题组',
    order_delivery_a: '配送',
    order_delivery_method: '配送方式',
    order_delivery_method_colon: '配送方式:',
    order_self_take: '请提前联系配送管理员，预约实际取货时间',
    order_delivery_message: '现货产品预计2个工作日内送达',
    order_stock_delivery_message: '有库存产品预计2个工作日内送达',
    order_host: '配送员',
    order_inventory_colon: '库存:',
    order_submit_order_again:
        '有可能导致订单信息发生变化，请至订单列表重新下单',
    order_confirm_select: '确认选择',
    order_no_name: '无',
    order_total_colon: '合计：',
    order_next_step: '下一步',
    order_submit_order: '提交订单',
    order_confirm_information_again: '再次确认信息',
    order_complete_confirm: '确认无误，提交订单',
    order_complete_confirm_new: '已备齐所有入单支持文件，确认提交订单',
    order_confirm_submit: '确认提交',
    order_sumbit_success: '订单提交成功',
    oerder_number: '订单号',
    order_number_colon: '订单号：',
    order_sc_order_number: '现货中心订单号：',
    order_global_order_number: '官网订单号：',
    order_fone_order: 'F1订单',
    order_my_order: '我的订单',
    order_global_delivery: '此产品将由网站物流配送',
    order_your_preferential_price: '（您的优惠价）',
    order_preferential_price: '（优惠价）',
    order_list_price: '（目录价）',
    order_global_price: '（飞享价）',
    order_discount_price: '（折扣价）',
    order_please_confirm: '请确认：',
    order_r_quote_please_confirm:
        '您的购物车中有一个或多个飞享价产品，飞享价不能与R促销代码一同使用，继续应用促销代码会导致飞享价失效。',
    order_r_quote_info:
        '提示：可将飞享价产品与其他产品分开下单，是否要应用优惠/促销代码？',
    order_contact_us: '联系我们',
    order_contact_service: '请联系客服',
    order_phone_colon: '电话：',
    order_service_mobile: '4008208982（手机）',
    order_service_phone: '8008208982（座机）',
    order_service_mail: '邮箱：',
    order_service_mail_details: 'cssh@lifetech.com',
    order_save_colon: '节省：¥ {0}',
    order_sc_product_delivery: '（专员配送，现货产品最快当天送达）',
    order_sc_stock_product_delivery: '（专员配送，有库存产品最快当天送达）',
    order_global_product_delivery: '（以网站物流配送时效为准）',
    order_global_serach_result: '赛默飞网站产品搜索',
    order_search_no_result: '未搜索到相关产品,详情请联系我们',
    order_search_tf_no_result: '没找到你的产品？请使用精确货号或英文关键词搜索',
    order_service_hot_line: '客服热线：',
    need_help_contact_us: '如需帮助，请联系我们',
    contact_telephone_one: '400 820 8982',
    contact_telephone_two: '800 820 8982',
    order_service_hot_line_number: '8008208982',
    order_service_hot_line_number_two: '4008208982',
    order_business_consult: '业务咨询：',
    order_business_consult_email: 'supplycenterchina@thermofisher.com',
    order_appoint_delivery: '请提前联系配送管理人员,预约实际取货时间',
    order_choose_other_address: '选择其他地址 >',
    order_self_pick_up: '自提',
    order_self_other: '其他',
    order_self_express: '快递',
    order_delivery: '送货',
    order_sc_delivery_details: '现货产品预计2个工作日内送达',
    order_details: '订单详情',
    order_preview: '预览',
    order_sign_receipt: '签收单',
    order_express_number: '快递单号',
    order_sign_date: '签收时间',
    order_cancel_order: '取消订单',
    order_partial_receipt: '部分收货',
    order_full_receipt: '全部收货',
    order_buy_again: '再次购买',
    order_confirm_cancel_order: '确认取消该订单吗?',
    order_confirm: '确定',
    order_cancel_order_by_service: '网站配送订单需联系客服取消。',
    order_quote_order_by_service_customer:
        '该订单含有特定促销代码，暂不支持直接取消，如需取消请联系销售或客服',
    order_quote_order_by_service:
        '该订单含有特定促销代码，暂不支持直接取消，如需取消请联系客服',
    order_service_email: '邮箱：cssh@thermofisher.com',
    order_not_upload_sign_receipt: '没有上传签收单',
    order_partial_receipt_confirm: '部分收货确认',
    order_full_receipt_confirm: '全部收货确认',
    order_current_shippment_number_colon: '此次实发数量:',
    order_confirm_receive: '确认收货',
    order_number: '订单编号',
    order_purchase_date: '购买时间',
    order_eone_number: 'E1单号',
    order_eone_status: 'E1状态',
    order_eone_hold: 'E1 Hold',
    order_total_amount: '订单总额',
    order_customer_order: '客户订单',
    order_ship_to_number: '账户编号',
    order_same_supply_center: '同现货中心',
    order_type_placeholder: '请选择订单类型',
    order_status_placeholder: '请选择订单状态',
    order_purchase_date_placeholder: '请选择购买日期',
    order_tm_query_Key_error: '搜索关键字不少于3个字符',
    order_discount_code: '促销代码',
    order_wharehouse: '发货仓库',

    shopping_cart_delete_button: '删除',
    shopping_cart_cancel: '取消',
    shopping_cart_current_sc: '当前为{0}',
    shopping_cart_choose_preferential_type: '选择价格',
    shopping_cart_discount_price: '折扣价',
    shopping_cart_discount_price_message: '显示您使用促销代码后的折扣价格',
    shopping_cart_global_price: '飞享价',
    shopping_cart_global_group_best_price: '最优价',
    shopping_cart_group_best_price_message:
        '系统将从此产品含有的促销折扣飞享价以及客户目录价中为您选择最优价格',
    shopping_cart_clear: '清除',
    f1_order_receive_select_all: '全选',
    shopping_cart_select_all: '全选',
    shopping_cart_settle: '去结算({0})',
    shopping_cart_delete: '删除({0})',
    shopping_cart_apply_failure: '促销代码应用失败, 请联系管理员',
    shopping_cart_close: '关闭',
    shopping_cart_add_hot_recommended: '推荐产品已添加到购物车',
    shopping_cart_empty: '您的购物车还是空的',
    shopping_cart_s_quote_remove:
        '请确认与促销码关联的所有产品将从购物车中被移除。',
    shopping_cart_confirm_msg_one: '应用{0}',
    shopping_cart_confirm_msg_two: '将自动添加以下产品至购物车',
    shopping_cart_change_shipment: '更改发货',
    shopping_cart_currently_no_match_condition_sku: '当前没有符合更改条件的SKU',
    shopping_cart_apply_m_quote_message:
        'M Quote适用产品仅支持大仓配送，您可选择将M Quote适用产品与其他产品分开下单，请确认是否要应用本促销代码',
    shopping_cart_error_code_E1PQ40_message:
        '促销代码应用失败，因本促销代码价格高于飞享价，本促销代码无法使用.',
    shopping_cart_error_code_E1PQ35_message:
        '促销/报价对购物车中的商品或数量无效.',
    shopping_cart_assayid_placeholder: '请输入Assay ID',
    shopping_cart_assayid_checked: '检查',
    shopping_cart_invalid_assayId: '输入的货号和ID不是有效的组合',
    shopping_cart_empty_assayId: '缺少商品属性：检测Assay ID',

    current_shippment_quantity_colon: '此次发货数量:',
    shippment_quantity_colon: '实发数量:',
    not_shippment_quantity_colon: '未发数量:',
    shippment_current_inventory_colon: '当前库存:',
    shippment_confirm_delivery_amount: '确认发货数量',
    shippment_express_number_colon: '快递单号:',
    shippment_order_details: '订单详情',
    shippment_order_number: '订单编号',
    shippment_eone_number: 'E1单号',
    shippment_eone_status: 'E1状态',
    shippment_purchase_date: '购买时间',
    shippment_cancel_date: '取消时间',
    shippment_delivery_order: '发货单',
    shippment_sign_receipt: '签收单',
    shippment_preview: '预览',
    shippment_upload_again: '重新上传',
    shippment_edit_upload: '编辑',
    shippment_express_number: '快递单号',
    shippment_sign_date: '签收时间',
    shippment_delivery_date: '发货日期',
    shippment_expect_ship_date: '期望发货时间',
    shippment_cancel_order: '取消订单',
    shippment_withdrawal_of_package: '撤回包裹',
    shippment_temporary_not_delivery: '暂不发货',
    shippment_temporary_all: '全部',
    shippment_temporary_not_shipped: '暂不发货',
    shippment_temporary_pending_shipped: '非暂不发货',
    temporary_not: '暂不发货',
    shippment_delivery: '发货',
    shippment_take_goods: '收货',
    shippment_upload_signature_method_title: '签收方式',
    shippment_upload_signature_send_delivery_code: '请发送签收码给客户',
    shippment_upload_signature_method_select: '请选择客户收货方式：',
    shippment_upload_signature_method_customer: '客户签收',
    shippment_upload_signature_method_delegate: '指定位置签收',
    shippment_upload_signature_method_sms_tip: '系统将发送签收码至手机号:',
    shippment_upload_signature_method_tel: '手机号:',
    shippment_upload_signature_method_email: '邮箱:',
    shippment_upload_signature_method_send_info:
        '若客户无法收到短信或邮件，也可引导客户通过掌上赛默飞订单物流动态获取签收码。',
    shippment_upload_signature_method_send_code: '发送短信到手机获取签收码',
    shippment_upload_signature_method_sent_delivery_code: '发送签收码',
    shippment_upload_signature_method_code_sent: '已发送签收码',
    shippment_upload_signature_method_code_not_resent: '再次发送签收码',
    shippment_upload_signature_method_sentto_code: '签收码将发送至',
    shippment_upload_signature_method_input_label: '请输入签收码：',
    shippment_upload_signature_method_input_label_input_hint:
        '收到签收码后，请在此处输入签收码：',
    shippment_upload_signature_method_input_placeholder: '请输入签收码',
    shippment_upload_signature_method_input_hint: '收到签收码后，请在此处填写',
    shippment_upload_designated_location: '上传货品放置图片',
    shippment_upload_click_designated_location_by_photo:
        '点击此处拍照上传货品放置图片',
    shippment_upload_recipient_mobile_number_cannot_be_empty:
        '收货手机号码不能为空',
    shippment_upload_send_code_success: '验证码发送成功',
    shippment_upload_send_code_failure: '验证码发送失败',
    shippment_upload_send_code_tel_incorrect: '手机号无效，请检查',
    shippment_upload_send_code_status_incorrect: '订单状态不是待收货',
    shippment_upload_product_placement_photo: '货品放置图片',
    shippment_upload_receive_code: '签收码',

    shippment_not_upload_sign_receipt: '没有上传签收单',
    shippment_upload_sign_receipt: '上传签收单',
    shippment_upload_sign_receipt_by_photo: '请拍照上传签收单',
    shippment_upload_sign_receipt_by_photo_here: '点此处拍照上传签收单',
    shippment_upload_other_photos: '上传其它照片',
    shippment_other_photos: '其它照片',
    shippment_upload_other_photos_here: '点击此处上传其它照片（可多张）',
    shippment_upload_other_photos_selected: '已选择 {0}/{1} 张',
    shippment_upload_other_photos_add: '添加',
    shippment_upload_other_photos_limit: '上传其它照片最多支持 {0} 张',
    shippment_not_upload_other_photos: '没有上传其它照片',
    shippment_upload_other_photos_failed: '上传失败',
    shippment_confirm_upload: '确认上传',
    shippment_confirm_cancel_order: '确认取消该订单吗?',
    shippment_confirm: '确定',
    shippment_confirm_temporary_delivery: '暂不发货确认',
    shippment_if_temporary_delivery: '确认暂不发货吗?',
    shippment_see_temporary_delivery_list: '可在暂不发货列表查看',
    shippment_confirm_wait_delivery: '待发货确认',
    shippment_if_wait_delivery: '确认待发货吗?',
    shippment_see_wait_delivery_list: '可在待发货列表查看',
    notification_already_wait_query_deliver_list:
        '已待发货，可到待发货列表查看！',
    shippment_self_pick_up: '自提',
    shippment_receiver: '收货人',
    shippment_contact: '联系方式',
    shippment_remark: '备注',
    shippment_eone_number_hyphen: 'E1单号',
    shippment_all_order: '全部订单',
    shippment_total_pieces: '共{0}件',
    shippment_serveral_times: '第{0}次',
    shippment_inventory_logistics_information: '库存和E1发货详情',
    shippment_details_shipment_number: '运单号',
    shippment_details_backorder_date: 'Available Date',
    shippment_details_actual_ship_date: '发货日期',
    shippment_details_shippment_state: '状态',
    shippment_details_shippment_quantity: '发货数量',
    shippment_recommended_list: '推荐单',
    shippment_all_available: '全部可发',
    shippment_partial_shipping: '部分可发',
    shippment_not_shipping: '不可发货',
    shippment_add_tracking_number: '添加运单号',
    shippment_input_tracking_number: '输入运单号',
    shippment_b2b_casmart_btn: '配送单',
    shippment_b2b_shipping_order_message:
        '此单需要打印喀斯玛配送单，请在打印发货单后到待收货订单中下载',
    shippment_query_coa: '查询COA',
    shipment_coa_analysis_certificate: 'COA分析证书',
    shipment_coa_application_repeat: 'COA 申请',
    shipment_coa_sku: '货号',
    shipment_coa_batch_no: '批次',
    shipment_coa_no_data: '暂无COA数据',
    shipment_coa_no_data_prefix: '抱歉，我们无法找到此搜索项相关的COA',
    shipment_coa_lot_null_prefix:
        '请知晓：如货号的批次为空值，则无法申请获取COA。',
    shipment_coa_apply_now: '一键申请COA',
    shipment_coa_download: '下载',
    shipment_coa_query_more: '查询更多',
    shipment_coa_apply_dialog_title: '申请COA',
    shipment_coa_apply_dialog_desc: '是否确认申请COA？',
    shipment_coa_loading: 'COA查询中...',
    shipment_coa_catalog_number_empty: '当前发货单未找到可查询的SKU',
    shipment_coa_query_failed: '查询COA失败',
    shippment_punch: '打卡',
    shippment_punch_success: '打卡成功.',
    shippment_exception_punch_success: '异常打卡成功.',
    shippment_refresh_map: '刷新',
    shippment_more_than_punch_scope: '您超过了打卡范围',
    shippment_not_punch: '您不在打卡范围，还不能打卡',
    shippment_inaccurate_positioning_system: '系统定位不准',
    shippment_forget_punch: '忘记打卡',
    shippment_customer_pickup: '客户自提',
    shippment_permission_disabled: '您禁用了定位权限，需要开启设备的定位权限',
    shippment_punch_exception_other: '其他',
    shippment_punch_exception_other_type: '请输入备注',
    shippment_upload_signed_first_punch: '上传签收单前，请先打卡',
    shippment_exception_punch: '异常打卡',
    shippment_punch_position_is_not_null: '客户坐标不能为空',
    shippment_exception_punch_status_is_not_null: '请选择打卡异常类型',
    shippment_customer_feedback: '客户反馈',
    shippment_customer_feedback_success: '客户反馈添加成功',
    shippment_customer_feedback_submit: '提交',
    shippment_customer_feedback_cancel: '取消',
    shippment_please_input_customer_feedback:
        '请输入收货人角色、客户推荐单内容偏好、客户机会、产品使用疑问等信息...',
    shippment_customer_feedback_content_is_not_null: '客户反馈内容不能为空',
    shippment_feedback_history: '反馈历史',
    shippment_please_input_tracking_number: '请输入运单号',
    shippment_select_lot_and_quantity: '选择批次及数量',
    shipment_lot: '批次:',
    shipment_recommended_label: '推荐',
    shipment_cannot_be_null: '请您至少选择一个sku发货,包裹不能为空',
    shipment_quantity_out_current_inventory: '发货数量不能大于当前库存',
    shipment_all_lot: '全部批次',
    shipment_confirm_delivery: '确认发货吗？',
    shipment_sku_incorrect: 'SKU {0} 发货数量不合适',
    shipment_delivery: '确认发货({0})',
    shipment_delivery_infor: '发货信息',
    shipment_details: '包裹详情',
    shippment_delivery_details: '发货详情',
    shippment_delivery_id: '发货单号',
    shippment_shipped_express_number: '顺丰单号',
    shipment_sku_lot: '批次',
    shipment_cancel_time: '取消时间',
    shipment_cancel_quantity: '取消数量',
    shipment_wait_quantity: '待发货数量',
    shipment_received_date: '签收日期',
    shipment_delivered_package_count: '已发{0}个包裹',
    shipment_unread_message: '您有未读消息,请处理',
    shipment_fold_info: '折叠信息',
    shippment_accompany_goods: '随单任务',

    shipment_my_order_picking: '我的拣货单',
    shipment_pick_list: '拣货单',
    shipment_pick_not_shippment_quantity_colon: '未发数量',
    shipment_pick_expiry_date: '效期',
    shipment_pick_expand_less: '折叠信息',
    shipment_pick_expand_more: '展开信息',
    shipment_pick_all_expand_less: '全部折叠',
    shipment_pick_all_expand_more: '全部展开',
    shipment_preview_pick_list: '预拣单',
    shipment_pick_delete: '删除',
    shipment_pick_all: '全部',
    shipment_pick_please_select_pick_order: '请选择需要删掉的拣货单.',
    shipment_pick_delete_pick_order_success: '删除拣货单成功',
    shipment_pick_confirm_delete_pick_order: '确认删除拣货单',
    shipment_pick_is_confirm_delete_pick_order: '确认删除拣货单?',
    shipment_preview_pick_order: '预拣货',
    shipment_pick_confirm_preview_pick_order: '确认预拣货',
    shipment_pick_is_confirm_preview_pick_order: '确认预拣货吗?',
    shipment_preview_pick_order_success: '预拣货成功',
    shipment_preview_pick_order_sku_shipment_is_null: 'sku发货列表为空',
    shipment_preview_pick_order_sku_is_null: 'sku列表不能为空',
    shipment_pick_please_select_preview_pick_order_sku:
        '请选择需要预拣货的SKU.',
    shipment_preview_more: '更多',
    shipment_preview_delivered_quantity_greater_than__undelivered_quantity:
        '{0}发货数量大于未发货数量',
    shipment_preview_order_non_existent: '订单不存在',
    shipment_preview_inconsistent_order_status: '订单状态不符',
    shipment_preview_inconsistent_order_type: '订单类型不符',
    shipment_preview_lock_or_review_order: '订单审核中或有锁',
    shipment_preview_order_has_been_picked: '订单已拣货',
    shipment_preview_no_component_sku: 'kit下的部分sku缺失',
    shipment_preview_component_quantity_incorrect: 'sku 数量不正确',
    shipment_preview_component_suit_incorrect: 'component 套数不一致',
    shipment_preview_ship_quantity_zero: '某个sku套数为0',
    shipment_preview_ship_quantity_incorrect: '发货数量大于未发货数量',
    shipment_order_shippe_separately: '订单是否单独发货',
    shipment_picking_order_is_separately_shipment:
        '该订单已在拣货单。若仍坚持单独发货，该订单将从拣货单删除',
    shipment_pick_please_select_shipment_pick_order: '请选择需要发货的拣货单.',
    shipment_pick_order_has_unread_message: '订单有未读信息，请在发货前阅读.',
    shipment_pick_order_inventory_less_than_quantity_shipped:
        '库存小于发货数量.',
    shipment_pick_batch_delivery: '确认批量发货',
    shipment_pick_confirm_batch_delivery: '确认批量发货吗？',
    shipment_pick_please_select_recommended_product: '请选择需要推荐的拣货单.',
    shipment_pick_batch_recommended_product: '确认批量打印推荐单',
    shipment_pick_confirm_batch_recommended_product: '确认批量打印推荐单吗？',
    shipment_pick_confirm_batch_pick_order_preview: '确认批量打印拣货单',
    shipment_pick_confirm_batch_pick_order_pdf: '确认批量打印拣货单吗？',
    shipment_pick_please_select_pick_order: '请选择需要打印的拣货单.',
    shipment_pick_you_have_unread_message_please_read: '您有未读消息，请处理',
    shipment_pick_message_list_title: '消息列表',
    shipment_pick_message_list_button_next: '下一步',
    shipment_pick_order_num: 'Order Num',
    shipment_pick_update_address_to: '改地址到',
    shipment_pick_to: 'to',
    shipment_pick_storeCondition: '存储条件',
    shipment_pick_message_count: '{0}条消息',
    shipment_list_special_tags: '服务标签',
    shipment_list_special_tags_other_desc: '其他说明',

    my_order_on_hold: '暂不发货',
    my_order_on_hold_already_success: '暂不发货已成功',

    supply_center_suspended_business:
        '当前现货中心暂停营业，下单产品将由网站物流配送',

    host_abnormal_record: '报废产品记录',
    host_abnormal_lot_nubmer_colon: '批次号：',
    host_abnormal_nubmer_colon: '数量：',
    host_abnormal_expire_date_colon: '过期时间：',
    host_abnormal_exception_specification_colon: '异常说明:',
    host_abnormal_approval_status_colon: '审批状态：',
    host_abnormal_approved: '已审批',
    host_abnormal_rejected: '已驳回',
    host_abnormal_pending_approval: '待审批',
    host_abnormal_add: '添加',
    host_abnormal_reagent_add: '添加报废产品',
    host_abnormal_exception_details: '异常详情',
    host_abnormal_amount: '数量',
    host_abnormal_upload_photo: '上传照片凭证',
    host_abnormal_upload_photo_save: '上传凭证',
    host_abnormal_upload_here: '点此拍照上传照片凭证',
    host_abnormal_selece_scName: '请选择现货中心',
    host_abnormal_selece_lot: '请选择批次',
    host_abnormal_confirm_add: '确认添加',
    abnormal_scrapSort: '报废分类',
    host_abnormal_scrap_sort_placeholder: '请选择报废分类',
    abnormal_f1OrderNumber: 'F1单号',
    host_abnormal_f1_order_number_placeholder: '请输入该产品的F1单号',
    abnormal_DnOrderNumber: '运单号码',
    host_abnormal_dn_order_number_placeholder: '请输入该产品的运单号码',
    host_abnormal_valid_F1_order_number: '请输入有效的F1订单号',
    host_abnormal_Invalid_F1_Number: '无效的f1Number',
    host_abnormal_No_Shipment: '不存在已收货的shipment',
    host_abnormal_Mismatch_SC_F1Number: '不匹配的现货中心和订单号',
    host_abnormal_Empty_Sc: '现货中心不能为空',
    host_abnormal_No_Match_SC_F1_Number: '现货中心与F1单号不匹配',
    host_abnormal_true_number: '正确的 F1 Number',
    host_abnormal_Empty_f1_number: 'F1 number 不能为空',
    host_abnormal_f1_number_null: 'F1 number不存在',
    host_abnormal_express_number_null: '运单号码不能为空',
    host_abnormal_express_number_no: '运单号码不存在',
    host_abnormal_scrap_greater_receiving: '退货数量不能大于收货数量',
    host_abnormal_sku_lot_matching: 'SKU和Lot信息不匹配',
    host_fone_order_details: '订单详情',
    host_fone_shippement_information: '收货信息',
    host_fone_replenishment_amount_colon: '补货数量:',
    host_fone_receive_amount_colon: '收货数量:',
    host_fone_order_number: '订单编号',
    host_fone_e1_order_number: 'F1单号',
    host_fone_order_status: 'F1状态',
    host_fone_replenishment_date: '补货时间',
    host_fone_replenishment_amount: '补货数量',
    host_fone_receive_date: '收货时间',
    host_fone_receive_amount: '收货数量',
    host_fone_cancel_date: '取消时间',
    host_fone_received_amount: '已收货数量:',
    host_receipt: '收货',
    host_full_receipt: '全部收货',
    host_full_receive: '收货',
    host_full_ReceiveConfirm: '请确认是否收货？',
    host_receive_package_condition: '包裹条件',
    host_receive_not_package_condition: '这个订单没有包裹条件',
    host_receive_select_sku: '请选择这个SKU',
    host_receive_select_batch_sku: '请选择需要收货的SKU',
    host_receive_invalid_quantity: '收货数量不能为0',
    host_shipment_status: '发货状态',
    host_express_number: '运单号码',
    host_logistics_company: '物流公司',
    host_sku_type_of_number: '产品品类',
    host_tobe_shipped_quantity: '数量',
    host_product_sku: '产品货号',
    host_wait_quantity: '待发数量',
    host_product_specifications: '产品规格',
    host_lot_information: '批次信息',
    host_package_receive: '收货',
    host_confirm_receive: '确认收货吗？',
    host_completed_status: '已完成',
    host_incompleted_status: '未完成',
    host_advent_products_details_header: '锁定 过期产品管理',
    host_advent_products_item: 'Item: ',
    host_advent_products_expired_quantity: '报废数量: ',
    host_advent_products_type: '报废分类: ',
    host_advent_products_f1Number: 'F1单号: ',
    host_advent_products_expressNumber: '运单号码: ',
    host_advent_products_advent_quantity: '临期数量: ',
    host_advent_products_dnsa: 'DNSA: ',
    host_advent_products_expiration_date: '效期: ',
    host_advent_products_lot: '产品批次: ',
    host_advent_products_upload: '上传标签',
    host_advent_products_confirm_upload_tag: '确认标签上传',
    host_advent_products_advent_tag: '临期标签: ',
    host_advent_products_upload_tag_is_not_null: '上传标签不能为空',
    host_advent_product_specifications: '产品规格: ',
    host_advent_abnormal_label: '报废标签',
    sku_is_not_in_same_sc: '目标产品不在当前现货中心销售',
    host_internal_callout_order: '调出',
    host_internal_callin_order: '调入',
    enter_orderNo_sku_supply_center: '输入订单编号/SKU/现货中心',
    host_internal_withdrawal: '撤回',
    host_update_tracking_number: '更新运单号',
    host_tracking_number: '运单编号',
    host_internal_order_new_transfer: '新增调货',
    host_internal_order_current_sp: '当前现货中心',
    host_internal_order_transfer_to: '调货至',
    host_please_select_consignee: '请选择收货人',
    host_please_select_telephone: '请选择电话',
    host_please_confirm_transfer: '确认调货',
    transferToSupplyCenterId: '现货中心',
    skuNum: '货号',
    LotNum: '批次',
    host_internal_order_current_sp_not_equals_transfer_to_sp:
        '当前现货中心和调至现货中心不能选择相同的',
    host_internal_order_current_supply_center_not_null: '当前现货中心不能为空',
    host_internal_order_transfer_to_not_null: '调货至现货中心不能为空',
    host_internal_order_consignee_not_null: '收货人不能为空',
    host_internal_order_telephone_not_null: '电话不能为空',
    host_internal_order_shipping_address_not_null: '收货地址不能为空',
    host_internal_order_self_pick_up: '自配送',
    host_internal_order_create_number_less_than_current_inventory:
        '新增SKU数量应该小于等于当前库存',
    host_internal_order_sku_or_kit_not_null: '货号或批次不能为空',
    host_internal_order_sku_not_null: '货号不能为空',
    host_internal_order_need_one_sku: '至少保留一个货号',
    host_internal_order_lot_incorrect: '的Lot不正确!',
    host_internal_order_stock_shortage: '库存数量不足，请确认数量!',
    host_internal_order_sku_colon: 'SKU:',
    host_internal_order_create_success: '创建内部订单成功 单号',
    host_internal_order_lot_null_or_quantity_less_than_1: 'Lot为空或数量小于1',
    host_internal_order_sku_or_kit_null: 'SKU 或 Kit为空',
    host_internal_order_at_least_one_sku: '至少需要一个SKU',
    host_internal_order_lot_not_found: 'Lot找不到',
    host_internal_order_invali_status: '内部订单的状态不合法，不允许操作',

    host_message_list: '消息列表',
    host_message_list_admin: '管理员: ',
    host_message_list_to_user_name: 'To: ',
    host_message_list_from_user_name: 'From: ',
    host_message_list_task_category: '跟进大类: ',
    host_message_list_task_subcategory: '跟进子类: ',
    host_message_list_task_comments: 'Comments:',
    host_message_list_f1_order_message_list: 'F1订单消息列表',

    host_sales_on_hold_message:
        '该订单设置了暂不发货，系统不会触发补货，如需发货，请联系师傅。',
    host_sales_lock_order_message:
        '该订单目前处于锁定状态，现货中心会按已解锁订单的入单先后顺序进行发货。',
    host_sales_lock_order_message1: '该订单目前处于',
    host_sales_lock_order_message2: '锁定状态，',
    host_sales_lock_order_message3:
        '现货中心会按已解锁订单的入单先后顺序进行发货。',

    host_sales_on_hold_message1: '该订单设置了',
    host_sales_on_hold_message2: '暂不发货，',
    host_sales_on_hold_message3: '系统不会触发补货，如需发货请设置发货计划。',

    host_sales_important_note_message: '重要提示',
    host_sales_important_note_close: '关闭',

    fone_order_details: '订单详情',
    fone_order_number: '订单编号：{0}',
    fone_order_eone_number: 'E1单号：{0}',
    fone_order_details_replenishment_date: '补货时间：{0}',
    fone_order_replenishment_information: '补货信息',
    fone_order_number_colon: '订单编号：',
    fone_order_eone_number_colon: 'E1单号：',
    fone_order_eone_status: 'E1状态：',
    fone_order_receive_date: '收货时间：',
    fone_order_replenishment_date: '补货时间：',
    fone_order_receive_amount: '收货数量：',
    fone_order_replenishment_amount: '补货数量：',
    fone_order_specifications_colon: '规格：',
    fone_order_replenishing_colon: '正在补货中：',
    fone_order_out_of_stock_colon: '缺货：',
    fone_order_wait_delivery_colon: '待发货：',
    fone_order_hold_delivery_colon: '暂不发货：',
    fone_order_current_inventory_colon: '当前库存：',
    fone_order_current_inventory: '当前库存',
    fone_order_replenishing: '正在补货中',
    fone_order_pre_deliver_time: '预计发货时间',
    fone_order_inventory_detail_cs_email: 'CSforF1@thermofisher.com',
    fone_order_wait_delivery: '待发货',
    fone_order_current_actual_colon: '实际库存：',
    fone_order_current_locking_colon: '锁定库存：',
    fone_order_max_inventory_colon: '库存上限：',
    fone_order_current_lot: 'Lot: ',
    fone_order_ddsna: 'DDSNA: ',
    fone_order_dnsa: 'DNSA: ',
    fone_order_complete_date: '效期: ',
    fone_order_tobeshipped_quantity: '待发货数量: ',
    fone_order_stockout_quantity: '缺货数量: ',
    fone_order_locked_status: '锁定状态: ',
    fone_order_locked_reason: '锁定原因: ',
    fone_order_security_inventory_colon: '安全库存：',
    fone_order_backup_quantity: '备货数量：',
    fone_order_available_stock: '可用库存：',
    fone_order_add_to_cart: '加入F1购物车',
    fone_order_shopping_cart: 'F1订单购物车',
    fone_order_enter_comments: '请输入备注',
    fone_order_current_is: '当前为',
    textarea_max_length: '备注最大字数不得超过200',
    fone_order_select_all: '全选',
    fone_order_replenishment: '补货',
    fone_order_confirm_delete: '确认删除',
    fone_order_confirm_delete_message: '您确定要删除吗?',
    fone_order_confirm: '确定',
    fone_order_view_inventory: '查看库存',
    fone_order_specifications: '规格',
    fone_order_received_amount: '已收数量',
    fone_order_replenished_amount: '补货数量',
    fone_order_inventory_details: '库存详情',
    fone_order_total_add_cart: '一键加入F1购物车',
    fone_order_add_sku: '添加SKU',
    fone_order_cancel_order: '结束订单',
    fone_order_update_order: '更新订单',
    fone_order_confirm_cancel_order: '确认结束订单',
    fone_order_confirm_cancel_order_message: '您确定要结束订单吗?',
    fone_order_shippment_details: '收货详情',
    fone_order_storage_condition: '储存条件',
    fone_order_shipping_condition: '运输条件',
    fone_order_kit_detail: 'Kit详情',
    fone_order_query_by_sku: 'SKU属于黑名单列表',
    black_list_sku_reason: '黑名单原因',
    fone_order_out_stock: '无货',
    fone_order_recent_lot: '最近效期',
    fone_order_selected_lot: '已选效期',
    fone_order_selected_lot_add_success: 'Lot保存成功',
    fone_order_expiry_date_lot: '批次：',
    fone_order_half_year: '大于半年',
    fone_order_one_year: '大于一年',
    fone_order_same_lot: '同一批次',
    fone_black_sku_message: 'sku:{0}为黑名单',
    fone_order_on_the_parcel: '在途包裹',
    fone_order_dn_number: 'DN单号',
    fone_order_f1_number: 'F1单号',
    fone_order_branch_name: '发货大仓',
    fone_order_replenishment_time: '补货时间',
    fone_order_delivery_time: '发货时间',
    fone_order_internal_order_number: '内部订单号',
    fone_order_internal_delivery_warehouse: '发货仓库',
    fone_order_internal_order_status: '状态',
    fone_order_estimated_shipping_time: '预计发货时间',
    fone_order_estimated_delivery_time: '预计送达时间',
    fone_order_product_name: '产品名称：',
    product_shippingCondition: '运输温度',
    product_storeCondition: '存储温度',
    shippment_view_all_order_information: '查看全部订单信息',
    sub_product_shippingCondition: '运输温度: ',
    sub_product_storeCondition: '存储温度: ',

    shipping_plan: '发货计划',
    shipping_plan_dialog_submit: '提交',
    shipping_plan_dialog_cancel: '取消',
    shipping_plan_dialog_add: '添加发货计划',
    shipping_plan_all_quantity: '总数量',
    shipping_plan_shipped_quantity: '已发数量',
    shipping_plan_quantity: '数量',
    shipping_plan_date: '日期',
    shipping_plan_remark: '备注',
    shipping_plan_add_success: '发货计划添加成功',
    shipping_plan_needed_one_plan: '至少需要一个发货计划',
    shipping_plan_quantity_cannot_exceed_total_quantity_SKUs:
        '发货计划的数量不能超过SKU总数量',
    shipping_plan_added_plan_cannot_delete: '已经添加的发货计划不能删除',
    shipping_plan_quantity_not_new_plan: '当前没有新添加的发货计划',
    shipping_plan_shipped_quantity_not_null: '发货计划数量不能为空',
    shipping_plan_shipped_date_not_null: '发货计划日期不能为空',
    shipping_plan_today_plan: '今日计划',
    shipping_plan_shipping: '发',
    shipping_plan_shipping_unit: '个',
    shipping_plan_complete: '已完成',
    shipping_plan_complete_confirm_message: '是否确认完成该发货计划？',
    shipping_plan_complete_suffix: '？',
    sales_shipping_plan_sync_reminder: '请按发货需求同步添加发货计划',
    common_operation: '操作',

    header_fone_order: 'F1订单',
    header_select_customer: '选择客户',
    header_delivery_management: '发货管理',
    header_fone_shippment_management: 'F1收货管理',
    header_abnormal_reagent_record: '报废产品记录',
    header_fone_refresh: '同步',

    black_user_not_settle: '您有账款逾期未结清',
    black_user_contact_service: '暂时不能下单，请联系销售',
    black_user_not_activate:
        '亲爱的客户，欢迎来到赛默飞现货供应中心。在这里，您可以享受到【专人配送】【最快一小时达】【微信随时快速下单】的一站式体验。官网产品一网打尽，正品保证省心省力。',
    welcome_reminder:
        '您现在浏览的是现货中心体验站，现阶段您的账户尚未被激活。请联系',
    cssh_email: 'cssh@thermofisher.com',
    enter_demo_site: '激活账户即可进入正式站体验完整功能。',
    please_contact: '如果账号激活后仍显示此页面，请联系',
    supplycenterchina_email: 'supplycenterchina@thermofisher.com',
    demo_site_learn_more: '了解详情。',

    welcome_demosite: '亲爱的客户，欢迎来到赛默飞现货供应中心。',
    return_tfs_website:
        '目前您周围没有现货供应中心提供服务，当前浏览的是现货中心体验站，如需返回',
    thermofisher_link: '掌上赛默飞',
    please_click_link: '，请点击',
    enjoy_ultimate_experience_one_stop_service: '享受一站式服务的极致体验。',
    mapac_thermofisher_email: 'mapac.thermofisher.cn',
    anyway_problem_please_call: '如果有其他问题，请联系',

    user_center: '个人中心',
    user_center_placeorder_for_customer: '代客户下单',
    user_center_create_order: '创建订单',
    user_center_view_all_order: '查看全部订单',
    user_center_not_receive: '未收货',
    user_center_received: '已收货',
    user_center_canceled: '已取消',
    user_center_fone_order: 'F1订单',
    user_center_replenishment_management: '补货管理',
    user_center_delivery_management: '发货管理',
    user_center_fone_receive_management: 'F1收货管理',
    user_center_inventory_query: '库存查询',
    user_center_inventory_details: '库存详情',
    user_center_abnormal_reagent: '报废产品',
    user_center_view_inventory: '查看库存',
    user_center_order_report: '订单报表',
    user_center_account_sync: '账户同步',
    user_center_account_sync_ST: 'Ship To 同步',
    user_center_account_sync_online: '官网账号同步',
    user_center_enter_sync_ST: '请输入您要同步的ST',
    user_center_enter_sync_online: '请输入您要同步的登录名',
    user_center_sync_login_name: '登录名',
    user_center_sync: '同步',
    user_center_sync_no_content: '未找到该账户',
    user_center_sync_success: '同步成功',
    user_center_sync_failed: '同步失败',
    user_center_test_warning_flag: '警告：这里是测试环境',
    user_center_proxy_delivery_order_management: '代配送订单管理',

    proxy_delivery_received_awaiting_status: '已收待发',

    proxy_delivery_order_management_order_number: 'E1单号',
    proxy_delivery_order_list_create_time: '下单时间',
    proxy_delivery_order_list_search_placeholder: '输入DN编号/E1单号/SKU',
    proxy_delivery_order_list_orderNo_EoneNo: '输入SKU/订单编号/E1单号',
    proxy_delivery_order_list_order_status: '订单状态',
    proxy_delivery_order_list_order_quantity: '下单数量:',
    proxy_delivery_order_list_estimated_delivery_time: '预计送达时间',
    proxy_delivery_package_upload_photo: '点此处拍照上传签收单',
    proxy_delivery_customer_receive: '客户收货',
    proxy_delivery_package_detail_not_exist: '包裹详情不存在',
    proxy_delivery_package_detail_not_found: '未找到包裹详情',
    proxy_delivery_package_detail_not_found_message:
        '抱歉，我们暂时无法找到包裹的详细信息',
    proxy_delivery_customer_receive_not_started: '客户收货还未开始',
    notification_customer_successful_receipt_of_goods: '客户收货成功',
    proxy_delivery_package_host_receive_confirm_text:
        '请确认本订单地址是否在配送范围内，若在配送范围内，请确认签收单包含签名和日期',
    proxy_delivery_package_customer_receive_confirm_text:
        '若客户本人验收，请确保签收单包含：签名+日期；若客户代签，请确保签收单包含：签名+日期+电话',
    proxy_delivery_go_on_receive: '再次收货',
    proxy_delivery_package_upload_file_bad_file_format:
        '上传的图片的格式不正确，允许上传的文件格式有：[jpg, jpeg, png]',
    proxy_delivery_signReceipt: '签收单',
    proxy_delivery_signReceipt_preview: '预览',
    proxy_delivery_sign_info: '签收信息',
    proxy_delivery_signReceipt_time: '签收时间',
    proxy_delivery_signReceipt_Host: '(师傅)',
    proxy_delivery_signReceipt_Customer: '(客户)',
    proxy_delivery_reject_reason: '拒收原因',
    proxy_delivery_reject: '拒收',
    proxy_delivery_reject_package: '拒收包裹',
    proxy_delivery_reject_remark: '拒收备注',
    proxy_delivery_reject_remark_required: '拒收备注不能为空',
    proxy_delivery_reject_reason_required: '拒收原因不能为空',
    proxy_delivery_confirm_reject: '确认拒收',
    proxy_delivery_reject_success: '拒收成功',
    proxy_delivery_customer_reject_success: '客户拒收成功',
    proxy_delivery_host_once_again_receive_success:
        '收货成功！请至已收待发列表下查看该包裹',
    proxy_delivery_customer_once_again_receive_success:
        '收货成功！包裹配送已完成',
    proxy_delivery_customer_reject: '客户拒收',
    proxy_delivery_delivery: '签收',
    proxy_delivery_reason: '原因: ',
    proxy_delivery_remark: '备注: ',
    proxy_delivery_reject_type_incorrect: '拒收类型不正确,请在此确认',
    proxy_delivery_package_not_allowed_reject: '当前包裹状态不允许拒收',
    proxy_delivery_package_status_not_allowed_to_receive:
        '当前包裹状态有变更，无法签收',
    proxy_delivery_package_SHIPMENT_NOT_EXIST: '包裹不存在',
    proxy_delivery_package_complete_not_reject: '包裹状态已完成，拒收失败',
    proxy_delivery_reject_label: '已拒收',
    proxy_delivery_shipto_remark: '签收要求',
    proxy_delivery_shipment_status: '包裹状态',
    proxy_delivery_order_quantity: '下单数量',

    user_center_task_management: '任务管理',
    user_center_task_management_search_placeholder: '订单编号/E1单号/SKU',
    user_center_task_management_tobe_completed: '待完成',
    user_center_task_management_in_follow_up: '跟进中',
    user_center_task_management_all_completed: '已完成',
    task_management_score: '分',
    task_management_mandatory: '强制',
    task_management_non_mandatory: '非强制',
    task_management_mandatory_task: '强制任务 × {0}',
    task_management_non_mandatory_task: '非强制任务 × {0}',
    task_management_key_point: '重点',
    task_management_latest: '最新',
    task_details: '任务详情',
    task_details_contact: '联系人',
    task_details_please_input_contact: '请输入联系人',
    task_details_phone: '电话',
    task_details_please_input_phone: '请输入电话',
    task_details_position: '职位',
    task_details_please_input_position: '请输入职位',
    task_details_submit: '已提交',
    task_details_go_back_order: '返回订单页',
    task_details_upload_image: '上传图片',
    task_details_confirm_upload_image: '确认上传图片',
    task_details_upload_here: '点此此处上传图片',
    task_details_assignment_customer: '指定客户列表',
    task_details_task_search_placeholder: '任务编号/任务名称/ShipTo/课题组',
    task_details_assignment_customer_search_placeholder: 'ShipTo/课题组',
    task_details_please_complete: '请在{0}之前完成',
    task_details_please_non_mandatory_complete_date: '有效期至{0}',
    task_details_task_name: '任务名称',
    task_management_progress_task_label: '继续跟进',
    task_management_progress_task: '继续跟进 × {0}',
    task_management_submitted_task: '已提交 × {0}',
    task_management_completed_task: '已完成 × {0}',
    task_details_view_task: '查看',
    task_details_multiple: '（多选）',
    task_details_single: '（单选）',
    task_details_gap_filling: '（填空）',
    task_details_query_customer: '寻找客户',
    task_details_select_customer: '选择客户',
    searchStQueryKey: '选择客户',
    task_details_closeness: '亲密度',
    task_details_submit_success: '任务提交成功',
    task_details_input_select_customer: '输入并选择客户',
    task_details_select_contacts: '选择联系人',
    task_details_please_select_contacts: '选择联系人',
    task_details_required_not_do: '您有必填题目未做，请仔细核查',
    task_details_input_content_max_100: '输入内容最大支持100字',
    task_details_contact_max_30: '联系人最大支持30字',
    task_details_position_max_20: '职位最大支持20字',
    task_details_task_info: '任务补充信息',
    task_details_tracking_status: '追踪状态',
    task_details_tracking_desc: '任务描述',
    task_details_message_desc: '回复',
    task_details_replay_message: '回复消息',
    task_details_messge_send_success: '消息发送成功',
    task_details_submit: '提交',
    task_details_p_submit: '已提交',
    task_progress_task_comments_not_null: '回复不能为空',
    task_details_number: '任务编号',
    task_details_subject: '课题组',

    user_center_account_confirm_frozen: '确认冻结',
    user_center_account_confirm_unfrozen: '确认释放',
    user_center_account_frozen: '冻结',
    user_center_account_unfrozen: '释放',
    user_center_account_enter_frozen_st: '请输入您要单个冻结的BT',
    task_details_not_customer_please_select_customer:
        '客户不能为空，请选择客户',
    task_details_please_select_closeness: '请选择亲密度',
    task_details_please_dropdown_select_customer: '请从下拉框中选择对应的客户',
    task_details_illegal_customer: '不合法的客户',

    user_center_contact_us: '联系我们',
    user_center_contact_amanda: 'AMandA',
    user_center_logout: '退出登录',
    user_center_logout_message: '您确认要退出登录吗？',
    user_center_delivery_colon: '现场配送：',
    user_center_order_choose_time: '选择订单时间',
    user_center_period: '至',
    user_center_report_send_to: '订单报表将发送至',
    user_center_confirm_send: '确认发送',
    user_center_account_information: '我的账户信息',
    user_center_default: '默认',
    user_center_set_default: '设为默认',
    user_center_application_backup: '申请备货',
    user_center_advent_products: '临期产品',
    user_center_hold_products: '锁定产品',
    user_center_your_message: '我的消息',
    user_center_clocked_signed: '打卡签收',
    user_center_punch_signed: '打卡签到',
    user_center_signed: '打卡',
    user_center_close: '关闭',
    user_center_long_desc_detail: '通知详细说明',
    user_center_notification_desc: '通知说明',
    shipment_punch_exception: '打卡异常',
    shipment_exception_punch: '异常打卡',
    clocked_signed_success: '您离目的地还有{0}米,在打卡范围内,打卡成功.',
    clocked_signed_failed: '您离目的地还有{0}米,不打卡范围内,打卡失败.',
    shipment_punch_host_checkin: '该订单有随单任务，请注意',

    backup_status_INIT: '待处理',
    backup_status_APPROVED: '已审批',
    backup_status_REVOKE: '已审批',
    backup_status_DECLINE: '已审批',
    backup_status_RECALL: '已取消',
    backup_delivery_date: '计划下单日期',
    backup_sc_not_cover_user_city: '您所管理的现货中心不覆盖用户所在城市',
    backup_plan_order_date: '计划下单时间',
    backup_delivery_date_placeholder: '请输入计划下单日期',
    backup_sku: 'SKU',
    backup_sku_placeholder: '请输入您要备份的SKU',
    backup_login_email: 'Login Email',
    backup_login_account: '账户',
    backup_lab_or_dept: '课题组',
    backup_lab_or_dept_placeholder: '请输入课题组',
    backup_supply_center: '现货中心',
    backup_supply_center_placeholder: '请选择现货中心',
    backup_please_select_supply_center: '请选择现货中心',
    backup_ship_to_placeholder: '请选择Ship To',
    backup_quantity: '备货数量',
    backup_apply: '申请备货',
    backup_comments: '备注',
    backup_comments_placeholder: '请输入备注',
    backup_institution: '单位',
    backup_institution_placeholder: '请输入单位',
    backup_list_title: '申请备货列表',
    apply_backup_title: '申请备货',
    apply_backup_submit: '确认申请',
    backup_please_input_sku: '请输入货号',
    backup_please_input_lot: '请选择批次号',
    backup_inventory: '库存',
    backup_inventory_quantity: '库存数量',
    backup_application_quantity: '申请数量',
    backup_application_reason: '备货原因',
    backup_application_other_reason: '备注',
    backup_application_other_reason_not_null: '备货原因为其他时，备注不能为空',
    backup_application_other_reason_not_more_than_100: '备注长度不能大于100',
    backup_application_reason_placeholder: '请选择备货原因',
    backup_please_input_other_reason: '请输入备注',
    backup_stockup_quantity: '备货情况：当前备货数量{0}',
    backup_your_application_quantity: '（您申请{0}）',
    backup_confirm_stock_up: '请确认备货申请单',
    backup_confirm_submit: '提交',
    backup_confirm_cancel: '取消',
    backup_line: '--',
    backup_onroad_quantity: '在途数量',
    backup_delete_button: '删除',
    backup_add_sku_button: '添加货号',
    backup_need_one_sku: '备货申请至少需要一个SKU',
    backup_not_application: ' 不能申请备货,',
    backup_due_to: ' 由于 ',
    backup_revoke: '撤销',
    backup_application_date: '申请时间',
    backup_revoke_successs: '撤销成功',
    backup_revoke_failure: '撤销失败',
    backup_revoke_backup: '撤销备货',
    backup_confirm_revoke_backup: '确定要撤销备货吗？',
    backup_revoke_backup_confirm: '确定',
    backup_host_sales_apply_goods:
        '我已知悉，该备货产品服务于7日内已确定的客户需求，相应批次不一定能分配到我下的订单，现货中心会按已解锁订单的入单先后顺序进行发货。',
    backup_apply_banner_info: '如果您的下单日期在七天之后，请暂勿申请备货。',

    product_management_small_to_big: '换成大规格',
    product_management_big_to_small: '换成小规格',
    product_management_specification_conversion: '规格转换',
    product_management_conversion_specification: '转换规格',
    product_management_conversion_confirm: '确认',
    product_management_product_converted: '该产品将被转换成',
    product_management_scilicet: '即 (',
    product_management_unit: ') 单位',
    product_management_big_size: '大规格',
    product_management_small_size: '小规格',
    product_management_sku: '货号：',
    product_management_nubmer_colon: '数量：',
    product_management_nubmer: '个',
    product_management_conversion_success: '转换成功',
    product_management_batch_deletion: '批量删除',
    notification_please_select_the_batch_deletion_item: '请选择批量删除的产品',
    product_management_convert_sku_out_stock: '转化数量大于当前库存，转换失败',
    product_management_sku_not_exist: '源sku不在当前现货中心，更改失败',
    product_management_convert_target_sku_not_exist:
        '目标sku不在当前现货中心，更改失败',
    product_management_convert_target_sku_number_error:
        '目标sku数量不对，更改失败',
    product_management_convert_target_sku_exist_multiple_components:
        '目标sku存在多个components，不能转换',
    product_management_convert_target_sku_source_not_convert: '源sku不能转换',

    b2b_management_config: 'B2B配置',
    b2b_management_please_select_shipto: '请输入shipTo',
    b2b_management_please_select_subject: '请输入上面shipTo查询课题组',
    b2b_management_platform: '客户平台',
    b2b_management_please_select_platform: '请选择平台',
    platformShipto: '平台ShipTo',
    b2b_management_please_select_platform_shipto: '请输入客户平台的课题组编号',
    b2b_management_use_wop: '使用WOP',
    b2b_management_use: '使用',
    b2b_management_not_use: '不使用',
    b2b_management_whether_split_order: '是否拆单',
    b2b_management_split_order_methods: '拆单方式',
    b2b_management_supply_center_inventory_split_order:
        '按现货中心库存（接受拆单）',
    b2b_management_customer_PO_number_split_order: '按客户PO号（不接受拆单）',
    b2b_management_contact_email: 'Contact Email',
    b2b_management_description: '描述',
    b2b_management_submit: '提交',
    b2b_management_update: '编辑',
    b2b_management_edit: '更新',
    b2b_management_shipto_not_null: 'ShipTo不能为空',
    b2b_management_subject_not_null: '课题组不能为空',
    b2b_management_supply_center_not_null: '现货中心不能为空',
    b2b_management_platform_not_null: 'Platform不能为空',
    b2b_management_save_success: '保存成功',
    b2b_management_platform_shipto_duplicate: 'Platform shipTo重复',
    b2b_management_platform_shipto_invalid: '输入的是无效的Ship To',
    b2b_management_shipto_invalid: '输入的是无效的Ship To',
    b2b_management_add: '添加',
    b2b_management_platform_list: 'B2B 平台列表',
    b2b_management_platform_list_wop: 'WOP',
    b2b_management_platform_list_shipTo: 'Ship To',
    b2b_management_query_subject: '查询课题组',
    b2b_management_enter_st_or_subject: '输入ST/课题组',
    b2b_management_not_found_st_bind: '该ST非当前销售绑定用户',
    b2b_management_input_add_email: '请输入邮箱并点击添加',
    b2b_management_input_description: '请输入描述',
    b2b_management_please_select_account: '请选择账户',
    b2b_management_platform_shipto_not_null: '平台ShipTo不能为空',

    st_management: 'ST管理',
    st_management_subject: '课题组',
    st_management_st_address: 'ST地址',
    st_management_current_sp: '当前现货中心',
    st_management_transation_method: '配送方式',
    st_management_application_changing: '申请变更中',
    st_management_apply_change: '申请变更',
    st_management_not_repeat_apply_change:
        '您已申请过该ST对应现货中心关系的变更！',
    st_management_confirm_apply: '确认申请',
    st_management_apply_reason: '申请原因',
    st_management_apply_sp: '申请现货中心',
    st_management_please_select_apply_sp: '请选择申请现货中心',
    st_management_shipto_address: 'ShipTo地址',
    st_management_apply_sp_is_not_null: '申请现货中心不能为空',
    st_management_apply_reason_is_not_null: '申请原因不能为空',
    st_management_apply_reason_length_not_more_than_200:
        '申请原因不能超过200个字',
    st_management_transation_method_is_not_null: '配送方式不能为空',
    st_management_apply_change_success: '申请变更成功',
    st_management_no: '无',
    st_management_please_enter_apply_reason: '请输入申请原因',
    st_management_have_received_apply: '我们已经收到您的申请',
    st_management_associated_sp: '关联现货中心',
    st_management_associated_sp_yes: '是',
    st_management_associated_sp_no: '否',

    mobile_label: '手机号',
    phone_label: '固话',
    i_got: '我知道了',
    input_required: '此项为必填',
    withdraw: '退出',
    loading: '正在加载...',
    shipment_list_load_failed: '订单列表加载失败',
    shipment_list_reload: '重新加载',
    already_in_the_bottom: '已经到底啦',
    record_number: 'ICP备案号：沪ICP备11003924号',
    business_license: '经营证照',
    search: '搜索',
    enter_sku_orderNo: '输入SKU/订单编号',
    enter_sku_orderNo_EoneNo: '输入SKU/订单编号/F1单号',
    enter_onload_package_search_criteria: '输入DN编号/F1单号/订单编号/SKU',
    search_history: '搜索历史',
    enter_express_number: '请输入快递单号',
    confirm_delivery_order: '请确认发货单是否显示价格:',
    delivery_order_label: '发货单是否显示价格:',
    show_eone_set_price: '该ST在E1中的价格设置为:',
    eone_set_show_price: '显示价格',
    eone_set_not_show_price: '不显示价格',
    display: '显示',
    not_display: '不显示',
    confirm_delivery: '确认发货',
    enter_orderNo_eoneNo_sku_subject_receiver_po:
        '订单编号/E1单号/SKU/课题组/收件人/PO',
    login: '登录',
    password_not_valid: '您的密码有误，请重新输入',
    enter_mobile: '请输入您的账号',
    enter_password: '请输入您的密码',
    userName: '用户名',
    password: '密码',
    enter_purchase_number: '请输入采购单号',
    enter_note: '请输入备注',

    enter_scNo_scName_orderNo: '输入SC编号/SC名称/订单编号',
    enter_scNo_scName_orderNo_EoneNo: '输入SC编号/SC名称/订单编号/E1单号',
    enter_sku: '输入SKU号',
    enter_sku_and_name: '输入sku编号或名称',
    enter_sku_need_add: '请输入您要添加的SKU',
    enter_orderNo_sku_subject_eoneNo: '输入订单编号/SKU/课题组/E1单号',
    exit: '退出',
    enter_sku_and_product_name: '输入sku或产品名称',

    enter_email_receive_report: '请输入接收订单报表的邮箱',
    enter_orderNo_eoneNo: '订单编号/E1单号',
    enter_order_purchase_number: '采购单号',
    ST: 'ST',
    enter_user_account: '用户账号',
    enter_order_status: '订单状态',
    enter_advanced_order_type: '订单类型',
    'query-order-more-options': '更多选项',
    invalid_token: '无效的token',
    invalid_userRole: '无效的用户角色',
    no_supply_center: '无现货中心',
    role_incorrect: '用户角色不正确',

    clause_content_one:
        '您同意适用于您所购买的产品的thermofisher.cn销售条款和条件。',
    clause_content_two: '点击查看销售条款及条件。',
    clause_content_three:
        '本网站销售的所有产品均不得用于人类或动物之临床诊断或治疗，仅可用于工业或者科研等非医疗目的。',

    feedback_write_here: '请在此写下您的意见反馈',
    feedback_confirm: '确认反馈',
    copy: '复制',
    company_stock: '公司库存',
    warehouse: '仓库：',
    available_quantity: '有效数量：',
    ddnsaDate: 'DDNSA Date：',
    dnsaDate: 'DNSA Date：',
    get_inventory_details_error1: '未获取到此SKU公司库存',
    is_not_delivery: '是否暂不发货',
    yes: '是',
    no: '否',
    promotion_code: '折扣代码:',
    in_stock: '有货',
    stockout: '缺货',
    short_of_stock: '紧张',
    to_send_the_goods: '待发货',
    wait_for_receiving: '待收货',
    have_been_signed: '已签收',
    off_the_stocks: '已完成',
    pending_orders: '待发货订单',
    Shipped_order: '已发货订单',
    part_of_the_shipment: '部分发货',
    Part_of_sign_after_receiving_STH: '部分签收',
    all_shipments: '全部发货',
    no_delivery_order: '暂不发货订单',
    signed_for_order: '已签收订单',
    cancelled_order: '已取消订单',
    partial_cancelled_order: '部分取消订单',
    received_order: '已收货订单',
    supply_center_goods: '现货中心商品',
    advance_payment: '预付款',
    TFS_goods: '官网商品',
    promotional_code: '请输入促销代码',
    discount_code: '促销代码',
    TFS_supply_center_experience_the_site: '赛默飞现货中心体验站',
    set_language: '语言设置',
    system_notification: '通知',

    b2b_management: 'B2B管理',
    internal_transfer_order: '内部调货',
    internal_transfer_order_detail: '内部调货详情',
    internal_transfer_order_shippingCondition: '运输温度',
    internal_transfer_order_storeCondition: '存储温度',
    internal_transfer_order_specifications: '规格信息',
    chinese: '中文简体',
    english: 'English',
    hot_recommended: '热门推荐',
    hot_recommended_cart: '为您推荐',
    hot_recommended_order: '您还可能感兴趣的产品',
    learn_more: '了解更多>',
    financial_status: '锁定-',
    order_status: '库存-',
    express_type: '配送-',
    all_order: '全部',
    no_lock: '无锁',
    locked: '有锁',
    order_in_stock: '有库存',
    no_stock: '无库存',
    direct_method: '直送',
    mail_method: '快递',
    CannotBelessThan3Words: '搜索不能小于3个字符',
    shipment_sales: '销售创建',
    shipment_customer: '客户创建',
    shipment_all_order: '全部',

    notification_successful_receipt_of_goods: '收货成功',
    notification_successful_delivery: '发货成功',
    notification_add_a_success: '添加成功',
    notification_picture_upload_failed: '图片上传失败',
    notification_update_proof_success: '更新凭证成功',
    notification_upload_at_least_one_proof: '请至少上传一张凭证',
    notification_all_goods_received_successfully: '全部收货成功',
    notification_the_batch_number_shall_not_exceed_15: '批次号不能超过15个',
    notification_order_cannot_be_operated: '此订单不能操作，请联系管理员',
    notification_successfully_cancel_the_order: '成功取消订单',
    notification_cancellation_request_has_been_sent:
        '您的取消申请已发送，如有问题请联系：supplycenterchina@thermofisher.com',
    notification_order_cancellation_failed: '订单取消失败',
    notification_please_select_picture: '请选择图片',
    notification_please_select_package: '请选择包裹',
    po_number_empty: '该订单没有PO number',
    notification_cancel_reason_not_exceed_90: '取消原因不能超过90个',
    order_has_confirmed: '客户已确认，订单无法取消',

    notification_already_temporarily_does_not_deliver_goods:
        '已暂不发货，可到暂不发货列表查看！',
    package_withdrawn_successfully: '撤回包裹成功',
    grey_list_products_can_not_be_temporarily_shipped:
        '该订单包含黑名单产品，不能暂不发货',
    failed_to_withdraw_package: '撤回包裹失败',
    withdrawal_of_package: '撤回包裹',
    confirm_cancellation_of_package: '确认要撤回该包裹？',
    cancellation_of_package_message1:
        '撤销包裹后，请联系销售在喀斯玛商城手动取消该发货状态，成功后可重新尝试发货。',
    cancellation_of_package_message2: '赛默飞订单号: {0}',
    cancellation_of_package_message3: 'PO号: {0}',
    cancellation_of_package_message4: 'SKU{0}: ',
    cancellation_of_package_message5: '数量: {0}',
    cancellation_of_package_copy: '全部复制',

    notification_successfully_upload: '上传成功',
    notification_confirmed_the_customer_receipt:
        '上传成功！您已成功确认客户收货！',
    notification_already: '已',
    notification_go_to: '，可到',
    notification_then: '还有',
    notification_jump_to: '您可以到',
    notification_view_order_details: '页面查看订单详情',
    notification_go_to_admin_view_f1_details: 'Admin管理端查看F1订单详情',
    notification_page: '页面',
    notification_list_to_view: '列表查看',
    notification_purchase_order_no_more_than_25_digits: '采购单号不能超过25位',
    notification_note_message_is_too_long: '备注信息过长',
    notification_please_check_and_confirm_the_terms: '请查看并确认条款',
    shippment_update_tracking_number_success: '更新运单号成功！',
    notification_expected_delivery_date_is_less_than_the_current_date:
        '期望发货日期小于当前日期',
    notification_order_generation_failed: '订单生成失败，请联系管理员',
    notification_promotion_code_applied_successfully: '促销代码应用成功',
    notification_promotion_code_final_price_is_best:
        '促销代码应用成功，目前最终价格已取优',
    notification_promotion_quote_exist: '该quote已存在，且应用成功',
    notification_order_promo_invalid:
        '此促销代码错误，请检查促销代码是否正确并准确输入',
    notification_order_promo_expired: '促销代码过期，请联系管理员',
    notification_order_promo_not_active_or_expired:
        '您输入的促销代码已过期或尚未生效',
    notification_order_promo_mismatch:
        '此促销代码不适用本订单，请检查您的促销代码是否使用正确',
    notification_order_promo_failed: '促销代码应用失败，请联系管理员',
    notification_invalid_combination_quote:
        '抱歉，此订单使用的促销代码数量已达到上限。您可拆分订单分别使用促销代码',
    notification_not_repeat_p_quote: '订单只能使用一张P优惠券',
    notification_not_repeat_d_quote: '订单只能使用一张D优惠券',
    notification_not_repeat_r_quote: '订单只能使用一张R优惠券',
    notification_not_repeat_m_quote: '订单只能使用一张M优惠券',
    notification_please_select_the_replenishment_item: '请选择所要补货产品',
    notification_invalid_cartId: '无效的购物车 ID',
    notification_invalid_st_or_bt:
        '当前客户ST/BT异常或无效，无法提交订单，请联系AMT或CSR团队跟进账户问题',
    notification_item_quantity_cannot_be_0: '物品数量不能为0',
    notification_feedback_submitted_successfully: '提交反馈成功',
    notification_copy_success: '复制成功',
    notification_purchase_start_time_shall_not_be_greater_than_the_end_time:
        '购买起始时间不能大于结束时间',
    notification_order_start_time_shall_not_be_greater_than_the_end_time:
        '订单起始时间不能大于结束时间',
    notification_order_report_has_been_sent_to_the_mailbox:
        '订单报表已发送到邮箱',
    notification_arrival_time_is_less_than_the_current_date:
        '到货时间小于当前日期',
    notification_we_have_received_your_application: '我们已收到您的申请',
    notification_successfully_applied_for_sku_listing: '申请SKU上架成功',
    notification_successfully_set: '设置成功',
    notification_others_have_been_cancelled: '个包裹，其他已取消',
    notification_system_crashed: '系统崩溃，已通知客服',
    notification_network_unstable: '网络不稳定，请稍后试试',
    notification_page_error: '页面错误，已通知客服',
    notification_unauthentication: '用户认证失败',
    notification_not_permission: '用户无此权限',
    notification_order_submission_failed: '订单提交失败',
    notification_invalid_sku: '无效的SKU号',
    notification_invalid_sku_price: 'SKU：{0}没有价格，不允许售卖',
    notification_invalid_phone: '无效的电话号码',
    notification_password_error: '密码错误',
    notification_refresh_page: '请刷新页面重试',
    notification_goods_failed: '收货失败',
    notification_receive_code_mismatch: '签收码不匹配，收货失败',
    notification_delivery_failed: '暂不发货失败',
    notification_delivery_failure: '发货失败',
    notification_no_delivery_order: '此订单不允许收货',
    notification_no_delay_shipment_order: '此订单不允许暂不发货',
    notification_gray_list_info: '灰名单产品，补到现货中心后立即发出',
    notification_no_shipment_order: '此订单不允许发货',
    notification_order_not_cancelled: '此订单不允许取消',
    notification_order_not_found: '找不到此订单',
    notification_change_failed: '修改失败',
    notification_delivery_quantity_error: '发货数量有误',
    notification_replenishment_quantity_error: '补货数量有误',
    notification_product_sent_wrong: '发送的产品有误',
    notification_order_cannot_be_partially_cancelled: '此订单不能部分取消',
    notification_product_repeatedly: '产品重复',
    notification_addition_failed: '添加失败',
    notification_no_sc: '您没有所属的现货中心, 请联系管理员',
    notification_the_number_of_exceptions_exceeds_the_actual_inventory:
        '异常数量超过实际库存',
    notification_the_quantity_shipped_exceeds_the_actual_stock:
        '发货数量超过实际库存',
    scrapped_quantity_is_not_greater_than_actually_inventory:
        '提交数量大于实际库存',
    notification_sku_not_exist: '该货号不存在',
    notification_sku_not_valid: '货号在所属的现货中心无效',
    notification_file_upload_failed: '文件上传失败',
    notification_login_again: '请重新登录',
    notification_tel: '联系电话 4008208982',
    notification_failed_to_buy_again: '再次购买失败',
    notification_no_order_report_is_available: '暂无订单报表',
    notification_no_sku: 'sku不存在',
    notification_yes_sku: 'sku通过',
    notification_user_details_were_not_obtained: '未获取到用户详情',
    notification_setup_failed: '设置失败',
    notification_order_report_delivery_failed: '订单报表发送失败',
    notification_no_deliveryman_information_was_obtained: '未获取到配送员信息',
    notification_order_locked:
        '由于您的账户存在逾期未结清或者超信用额度等财务情况，该订单目前无法发运。您可以随时联系我司销售，了解财务和发票处理情况。',
    notification_host_order_locked:
        '由于此用户账户存在逾期未结清或者超信用额度等财务情况，该订单目前无法发运。您可以随时联系我司销售，了解财务和发票处理情况。',
    notification_order_c1_and_c2_locked:
        '该账户存在逾期未结清或者超信用额度等财务情况，待信控团队审核解锁后发运。',
    notification_order_ed_locked:
        '该订单有备注，待ED release团队审核解锁后发运。',
    notification_order_other_locked: '订单审核中，待系统审核解锁后发运。',
    notification_quote_null: '没有此SKU的Quote信息',
    notification_get_quote_failed: 'Quote查询失败',
    notification_invalid_lock: '当前订单处于财务审核或者锁定，不能发货',
    pleaseSelectTransferto: '请选择转移至',
    transfer: '转移',
    stockTransform: '库存转换',
    include: '包含',
    includeProduct: '包含产品',
    submitSuccess: '提交成功 单号',
    submitFail: '提交失败',
    withdrawSuccess: '撤回成功 单号',
    withdrawFail: '撤回失败',
    cancelSuccess: '取消成功 单号',
    cancelFail: '取消失败',
    ReceiveSuccess: '收货成功 单号',
    ReceiveFail: '收货失败',
    transferPackage: '撤回调货',
    cancelPackage: '取消调货',
    confirmPackage: '确定取消调货吗？',
    confirmTransferPackage: '确认撤回调货吗？',
    nolotData: '当前无可转换批次',
    transferNumber: '转移数量',
    to_be_scrapped_quantity: '待报废数量不大于实际库存',
    copyall_btn_label: '一键复制',
    receive_repeat_tip: '收货请求已提交，请勿重复操作',
    apply_for_listing: '申请上架',
    apply_for_listing_product: '申请上架产品',
    apply_for_need_one_sku: '申请上架至少需要一个SKU',
    confirm_sku_info: '请确认sku信息',
    internal_order_expressway_self: '自配送',
    internal_order_expressway_express: '快递',
    internal_order_expressway_: '',
    btn_action_ok: '确认',
    btn_action_cancel: '取消',
    sku_is_in_black_list: '该SKU存在于黑名单列表',
    sku_is_invalid_sku: '无效产品，请确认',
    sku_is_exist_in_current_SC: '该SKU已存在于当前现货中心',
    sku_no_have_list_price: '没有获取到该SKU的价格',
    submit_sku_is_in_black_list: '部分SKU存在于黑名单列表',
    submit_sku_is_invalid_sku: '无效产品，请确认',
    submit_sku_is_exist_in_current_SC: '部分SKU已存在于当前现货中心',
    submit_sku_no_have_list_price: '没有获取到部分SKU的价格',
    revert_repeat_tip: '撤回调货请求已提交，请勿重复操作',
    transferSuccess: '调货成功 单号',
    transferFail: '调货失败',
    your_message_list: '消息列表',
    your_message_sign_read: '标为已读',
    your_message_read: '已读',
    your_message_unread: '未读',
    your_message_marked_read: '已标记为已读',
    your_message_admin_message: '管理员消息',
    your_message_order_message: '订单消息',
    your_message_task_message: '任务消息',
    your_message_system_message: '系统消息',

    transport: '运输',
    storage: '存储',
    your_message_qty: '数量',
    all_apply: '全部申请',
    all_apply_applicant: '申请人',
    all_apply_role: '角色',
    all_apply_apply_sc: '申请现货中心',
    all_apply_apply_time: '申请时间',
    all_apply_look_self: '只看自己',
    all_apply_approval_details: '审批详情',
    all_apply_approver: '审批人',
    all_apply_approval_time: '审批时间',
    all_apply_actual_supply_center: '实际现货中心',
    all_apply_actual_distribution_mode: '实际配送方式',
    all_apply_approval_comments: '审批意见',
    all_apply_ship_to_address: 'ShipTo 地址',
    all_apply_current_supply_center: '当前现货中心',
    all_apply_apply_supply_center: '申请现货中心',
    all_apply_apply_distribution_mode: '申请配送方式',
    all_apply_apply_reason: '申请原因',
    all_apply_direct_method: '直送',
    all_apply_confirm_backup: '您是否确认撤销该申请？',
    all_apply_confirm_backup_title: '撤销申请？',
    all_apply_confirm_invalid_status: '撤销状态无效',
    all_apply_confirm_No_right_to_cancel: '非本人申请，无权取消',
    all_apply_cancel_time: '取消时间',
    all_apply_Host: '师父',
    all_apply_Customer: '用户',
    all_apply_Sales: '销售',
    clock_comments: '拜访小结',
    clock_comments_input: '输入拜访小结',
    submit_record_comments: '提交',

    lto_history_list: '预购单历史',
    lto_history_order_wait_cusotmer_confirm: '待客户确认',
    lto_history_order_cusotmer_confirm: '客户已确认',
    lto_history_order_cusotmer_cancel: '已取消',
    lto_history_list_placeholder: 'PO编号/SKU/客户姓名/ST名称/预购单号',
    lto_history_list_st_name: 'ST名称',
    lto_history_list_st_number: 'ST编号',
    lto_history_list_customer_account: '客户账号',
    lto_history_list_recipient: '收件人',
    lto_history_list_po_number: 'PO编号',
    lto_history_list_total_sku: '共{0}件',
    lto_history_list_submit_time: '提交时间',
    lto_history_list_order_total_price: '订单总额',
    lto_history_list_notification: '再次通知',
    lto_history_list_cancel_notification: '取消订单',
    lto_history_list_cancel_reason: '取消原因',
    lto_history_list_cancel_reason_placeholder: '备注(可选)',
    lto_history_list_cancel_order_warning:
        '若您有任何问题，请及时联系您的销售处理',
    lto_history_list_notification_send_success: '通知发送成功',
    lto_history_list_resend_notification: '重新发送通知',

    lto_history_detail: '预购单详情',
    lto_history_order_total_price: '订单总额',
    lto_history_detail_24_hour_expiration: '23:59失效',
    lto_history_detail_23_59_hour_expiration: '23:59',
    lto_history_detail_expiration_time: '失效时间',
    lto_history_list_delivery_information: '收货信息',
    lto_history_list_bt_number: 'BT编号',
    lto_history_list_invoice_heading: '发票抬头',
    lto_history_list_invoice_address: '发票地址',
    lto_history_detail_product_sku: '产品货号',
    lto_history_detail_product_name: '产品名称',
    lto_history_detail_package_size: '规格',
    lto_history_detail_list_price: '目录价格',
    lto_history_detail_discount_price: '您的优惠价',
    lto_history_detail_tfs_product: '官网产品',
    lto_history_detail_sc_product: '现货中心',
    lto_history_detail_customer_cancel: '客户已取消',
    lto_history_detail_order_timeout: '订单已超时',
    lto_history_detail_order_revoke: '订单已撤回',
    lto_history_detail_confirm_time: '确认时间',
    lto_history_detail_cancel_reason: '取消原因',
    lto_history_detail_total_quantity: '共计{0}件',
    lto_history_detail_total_price: '总价',
    lto_history_detail_promotion_codes: '促销代码',
    lto_history_detail_order_information_sendto: '订单信息发送至',
    lto_history_detail_preorder_number: '预购单号',
    lto_history_detail_resend_channel_is_not_empty: '重新发送通知选项不能为空',

    lto_purchase_order_line_up: '预购单下单',
    lto_purchase_order_line_down: '上传凭证下单',
    lto_purchase_order_purchase_order_have_point:
        '预购单下单，客户可享会员中心积分',
    lto_purchase_order_tfs_customer: '官网用户',
    lto_purchase_order_st_number: 'ST编号',
    lto_purchase_order_subject: '课题组',
    lto_purchase_order_address: '地址',
    lto_purchase_order_mobility: '掌上赛默飞',
    phoneNumber: '短信',
    defaultEmail: '邮件',
    retentionTime: '保留时间至:',
    retentionTimeNotMoreThan14Days: '预购单保留时间请勿超过14天',
    lto_purchase_order_retention_time_not_empty: '保留时间至不能为空',
    lto_purchase_order_retention_time_is_less_than_the_current_date:
        '保留时间不能小于当前日期',
    retention_time_is_more_than_the_current_date: '保留至时间最大不能超过{0}天',
    confirm_phoneNumber: '短信确认:',
    confirm_email: '邮箱确认:',
    please_confirm_info_is_correct: '请确认以下信息是否正确:',
    information_confirm: '信息确认',
    online_confirm: '确认',
    information_na: 'NA',

    lto_history_detail_my_preorder_number: '我的预购单号',
    lto_purchase_order_customer_confirmation_channel: '客户确认渠道',
    lto_purchase_order_please_select_customer_confirmation_channel:
        '请选择客户确认订单的渠道及信息',
    lto_purchase_order_upload_purchase_order_for_annual_agreement_customer:
        '年协客户：上传用户入单PO',
    lto_purchase_order_upload_purchase_order_for_non_annual_agreement_customer:
        '非年协客户：上传用户入单合同',
    select_customer_confirmation_channel_phone_number: '请选择手机号',
    customer_confirmation_channel_checked_sms_not_empty:
        '客户确认渠道选中短信时，电话号码不能为空',
    offline_platform_customer: '平台客户, 以PO为准',
    offline_platform_customer_add_attachment: '添加附件',
    offline_platform_customer_information:
        '此处上传的凭证及合同等将会有相关团队进行审核',
    lto_purchase_order_is_not_submit_btn_label: '返回',
    lto_purchase_order_is_not_submit: '订单无法提交',
    lto_purchase_order_close_tip_info: '关闭',
    lto_purchase_order_please_advised: '请知晓',
    lto_purchase_order_please_advised_content1:
        '此订单在您通过现货中心提交后需客户进行确认，订单确认后客户即可获得会员中心积分。',
    lto_purchase_order_please_advised_content21: '客户可以通过掌上',
    lto_purchase_order_please_advised_content22: '赛默飞、短信',
    lto_purchase_order_please_advised_content23: '或',
    lto_purchase_order_please_advised_content24: '邮件',
    lto_purchase_order_please_advised_content25: '接收订单确认通知。',
    lto_purchase_order_please_advised_content3:
        '注：短信、邮件无需客户登录，可一键确认',
    lto_purchase_order_not_remind: '不再提醒',
    lto_purchase_order_timer: '({0}s)',
    offline_order_successfully_upload: '上传成功',
    lto_purchase_upload_file: '入单文件{0}',
    lto_purchase_upload_file_delete: '删除',
    lto_purchase_upload_file_image_too_large: '上传的图片不能大于{0}',
    lto_purchase_upload_file_bad_file_format:
        '上传的图片的格式不正确，允许上传的文件格式有：[jpg, jpeg, png, pdf, doc, docx]',
    lto_purchase_upload_file_confirm_upload_tag: '确认上传入单凭证',
    lto_purchase_order_customer_confirmation_link: '客户确认链接',
    lto_purchase_order_copy_confirmation_link: '复制确认链接',
    lto_purchase_order_copy_confirmation_link_to_customer_confirm_lto:
        '您可复制链接给到客户确认此预购单',
    lto_purchase_order_copy_link: '复制链接',

    upload_image_too_large: '文件大小超过限制',

    order_detail_purchase_order_voucher: '入单凭证',
    order_detail_purchase_order_voucher_for_po: '年协客户：入单凭证(PO)',
    order_detail_purchase_order_voucher_for_contract:
        '非年协客户：入单凭证(合同)',
    order_detail_purchase_order_voucher_preview: '下载',
    purchase_order_upload_here: '点此上传入单凭证',
    retentionTime_tip: '23:59',
    order_does_not_exist: '订单不存在',
    order_not_correct: '获取订单信息有误',
    welcome_to_website: '欢迎访问现货中心系统！',
    user_account_unauthorized:
        '您当前暂无权限访问此系统，若您需要开通权限，请联系',
    unauthorized_connect_email: 'SupplyCenter@thermofisher.onmicrosoft.com',
    offline_reminder_message1:
        '若您选择帮客户进行入单，当订单金额超过入单豁免线时 您需要在订单提交时上传以下入单凭证。',
    offline_reminder_message2:
        '1.请遵守《销售订单入单制度》，确保入单支持文件齐全，且须与客户签订双章销售合同。',
    offline_reminder_message3:
        '2.发货地址变更时，请按照公司《交货地址变更政策》提供符合要求的地址确认文件。',

    dealer_customer_info:
        '此用户系公司经销商，根据公司政策，请用户通过官网或线下自行下单',

    new_offline_reminder_message1:
        '上传凭证下单渠道仅适用于最终用户/垫款商金额在6万以下无凭证入单。根据公司合规政策要求，若用户为经销商（任意金额订单）或最终用户/垫款商单笔订单金额超过入单豁免线（即人民币6万元）时，',

    new_offline_reminder_message1_part2: '请提供补充用户入单合同/PO。',

    new_offline_reminder_message2:
        '1.请遵守《赛默飞中国销售流程——入单管理制度》，确保提交符合要求的入单支持性材料（例如：双章销售合同/PO）。',

    new_offline_reminder_message3:
        '2.发货地址变更时，请按照公司《交货地址变更政策》提供符合要求的地址确认文件。',

    offline_ordertotal_limit_exceed_message1:
        '根据《赛默飞中国销售流程——入单管理制度》，单笔订单超6万金额，无法在本系统入单，您可返回购物车进行调整或准备好以下入单材料进行线下入单。 请提交前再次核查订单总金额',

    offline_ordertotal_limit_exceed_message2:
        '1.请遵守《赛默飞中国销售流程——入单管理制度》，确保提交符合要求的入单支持性材料（例如：双章销售合同/PO）。',

    offline_ordertotal_limit_exceed_message3:
        '2.发货地址变更时，请按照公司《交货地址变更政策》提供符合要求的地址确认文件。',

    upload_file_format: '可上传的格式有：{0}',
    PromoDetails: '促销优惠',
    Savings: '立省',
    BestDiscount: '最优惠',
    MinOrderQty: '起购量',
    ProductItems: '个',
    GoToActivity: '前往活动页面',
    COPYPROMOTOUSE: '复制促销代码至购物车使用',
    OpenActivityPageFailed: '跳转活动失败',
    oem_custom_order_product: '定制入单产品',
    oem_product_promo_not_supported: '定制入单产品无法在线应用促销码。',
    oem_mixed_checkout_not_supported:
        '当前购物车包含定制入单产品，请将其与常规产品分开结算。',
    oem_order_remark_required: '请按要求填写备注',
    oem_order_remark_placeholder:
        '请填写产品单价及促销代码，如无促销代码请写明无促销代码',
    shipment_coa_apply_success: 'COA申请通知邮件发送成功',
    shipment_coa_apply_failed: 'COA申请通知邮件发送失败',
};

export default zh_CN;
